// extracted by mini-css-extract-plugin
export var banner = "_a-0";